import { Paper } from '@material-ui/core';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { useCallback, useEffect, useState } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { MdLocationOn } from 'react-icons/md';
import NumberFormat from 'react-number-format';
import useScrollToElement from '../../../../hooks/useScrollToElement';
import CustomInventoryDetails from '../CustomInventoryDetails';
import useStyles from '../styles';

const CustomInventoryItinerary = ({
  tripId, wrapperClassName, doHaveBorderAround, onMouseEnter, onMouseLeave,
  itinerary, doShowPrice, isInsideModal, isExpanded, doScrollToHotel,
}) => {
  const classes = useStyles();
  const [isDetailsOpen, setIsDetailsOpen] = useState(false);
  const itineraryEl = useScrollToElement({ value: doScrollToHotel && isExpanded.value });

  const handleDetailsClick = () => {
    setIsDetailsOpen((v) => !v);
  };

  const handleMouseEnter = useCallback(() => {
    if (onMouseEnter) {
      const { uniqueKey } = itinerary;
      onMouseEnter(uniqueKey);
    }
  }, [itinerary, onMouseEnter]);

  const handleMouseLeave = useCallback(() => {
    if (onMouseLeave) {
      onMouseLeave(null);
    }
  }, [onMouseLeave]);

  useEffect(() => {
    if (isExpanded.value) {
      setIsDetailsOpen(true);
    }
  }, [isExpanded]);

  return !itinerary ? <></> : (
    <div
      className={clsx('sm:p-3 p-2 grid grid-cols-4 gap-2 sm:gap-3', wrapperClassName, { 'border-2': doHaveBorderAround })}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      ref={itineraryEl}
    >

      <div className="border overflow-hidden h-auto md:h-40 align-middle col-span-4 md:col-span-1 auto-rows-min">
        {itinerary.image
          ? (
            <img
              src={itinerary.image}
              alt={itinerary.name}
              className="email-img"
            />
          ) : (
            <Paper square classes={classes} className="email-hidden-field">
              No photo
            </Paper>
          )}
      </div>
      <div className="col-span-4 md:col-span-2">
        <div className="font-bold">
          {itinerary.name}
        </div>
        {itinerary.destination && (
        <div className="text-sm -ml-1 mt-1">
          <MdLocationOn size="20" className="inline-block -mt-1" />
          {itinerary.destination}
        </div>
        )}
        <div className="text-gray-500">
          <div>
            {itinerary.feature ? (`${itinerary.feature}`) : ''}
            {itinerary.starRating > 0 ? (` • ${itinerary.starRating} Star`) : ''}
          </div>
          {itinerary.description}
        </div>
      </div>
      <div className="flex flex-col justify-between items-end col-span-4 md:col-span-1">
        <div className="text-right md:inline-block grid grid-cols-2 w-full md:w-auto">
          {doShowPrice && (
          <div className={clsx('font-bold leading-tight text-left md:text-right self-center', { 'text-sm': isInsideModal })}>
            <NumberFormat
              value={itinerary.cost.price}
              displayType="text"
              thousandSeparator
              prefix="from $"
              fixedDecimalScale="true"
              decimalScale="2"
            />
          </div>
          )}
          <div className={clsx({ 'col-start-2': !doShowPrice })}>
            <button onClick={handleDetailsClick} type="button" className="text-theme mt-1 focus:outline-none email-hidden-field">
              {!isDetailsOpen
                  && (
                    <>
                      <span>View details </span>
                      <FaChevronDown className="inline-block" />
                    </>
                  )}
              {isDetailsOpen
                  && (
                    <>
                      <span>Hide details </span>
                      <FaChevronUp className="inline-block" />
                    </>
                  )}
            </button>
          </div>
        </div>
      </div>
      <div className="col-span-4">
        {isDetailsOpen
            && (
              <CustomInventoryDetails itinerary={itinerary} tripId={tripId} />
            )}
      </div>
    </div>
  );
};

CustomInventoryItinerary.propTypes = {
  itinerary: PropTypes.shape().isRequired,
  tripId: PropTypes.string.isRequired,
  wrapperClassName: PropTypes.string,
  doHaveBorderAround: PropTypes.bool,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  doShowPrice: PropTypes.bool,
  isInsideModal: PropTypes.bool,
  isExpanded: PropTypes.shape({
    value: PropTypes.bool,
  }),
  doScrollToHotel: PropTypes.bool,
};

CustomInventoryItinerary.defaultProps = {
  wrapperClassName: undefined,
  doHaveBorderAround: true,
  onMouseEnter: undefined,
  onMouseLeave: undefined,
  doShowPrice: true,
  isInsideModal: false,
  isExpanded: undefined,
  doScrollToHotel: true,
};
export default CustomInventoryItinerary;
